import { Button } from "@/components/base/buttons/button";
import { Eyebrow } from "./panel-heading";
import { PasswordField, usePasswordConfirmation } from "./password-confirmation";

type Props = {
  eyebrow?: string;
  title: string;
  description: string;
  onCancel: () => void;
  onConfirm: (password: string) => Promise<void>;
};

export const ConfirmPasswordPanel = ({ eyebrow, title, description, onCancel, onConfirm }: Props) => {
  const { form, submit } = usePasswordConfirmation(onConfirm);

  return (
    <form className="flex max-w-[420px] flex-col gap-5 p-6" onSubmit={submit} noValidate>
      <div className="flex flex-col gap-1">
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
      <PasswordField control={form.control} label="Password" autoFocus />
      <div className="flex items-center gap-3">
        <Button type="submit" isLoading={form.formState.isSubmitting}>
          Continue
        </Button>
        <Button type="button" color="tertiary" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
};
